import { CartItem } from '@/types/cart.types';

export function getCartItemPrice(item: CartItem): number {
  return item.discountedPrice ?? item.price ?? 0;
}

export function hasCartItemDiscount(item: CartItem): boolean {
  return item.discountedPrice !== undefined
    && item.price !== undefined
    && item.discountedPrice < item.price;
}

export function isPromotionalCartItem(item: CartItem): boolean {
  return Boolean(item.promotionId);
}

export function hasCartItemCouponDiscount(item: CartItem): boolean {
  return hasCartItemDiscount(item) && !item.promotionId;
}

export function getCartTotal(items: CartItem[]): number {
  return items.reduce((total, item) => total + getCartItemPrice(item), 0);
}

export function getCartCouponDiscountTotal(items: CartItem[]): number {
  return items.reduce((total, item) => {
    if (!hasCartItemCouponDiscount(item)) {
      return total;
    }

    return total + ((item.price ?? 0) - getCartItemPrice(item));
  }, 0);
}

export function getCouponAppliedItemCount(items: CartItem[]): number {
  return items.filter(hasCartItemCouponDiscount).length;
}
